import moment from 'moment'
import api from '@/api'

export default {

  getPdf (pdfTemplate, item, langCode) {
    api.getOneItemWithFilters(this.apiUrl, 'pdfTemplates', pdfTemplate._id,
      [{
        key: 'contentItemId',
        value: item._id
      }, {
        key: '_lang',
        value: langCode
      }])
      .then((response) => {
        if (response.pdfContent) {
          let element = document.createElement('a')
          // element.setAttribute('href', 'data:text/html,' + response.htmlContent)
          element.setAttribute('href', 'data:application/pdf;base64,' + response.pdfContent)
          element.setAttribute('download', this.moduleName + '_' + pdfTemplate.name + '.pdf')
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        }
      })
  },

  fieldBackgroundColor (value, field) {
    return value
      ? this.cs.colorForInputBackgroundIfFilled || this.cs.colorForInputBackground
      : field.info.required
        ? this.cs.colorForInputBackgroundIfRequired || this.cs.colorForInputBackground
        : this.cs.colorForInputBackground
  },

  showDate (date) {
    return moment(date).format('DD.MM.YYYY')
  },

  showDatetime (date) {
    return moment(date).format('DD.MM.YYYY HH:mm')
  },

  showDatetimeOrTimeAgo (date, days) {
    if (days && moment().diff(moment(date), 'days') <= days) {
      return moment(date).fromNow(true)
    }
    return this.showDatetime(date)
  },

  translation (fieldName) {
    if (this.translations &&
      this.translations[this.language] &&
      this.translations[this.language][this.moduleName] &&
      this.translations[this.language][this.moduleName][fieldName]) {
      return this.translations[this.language][this.moduleName][fieldName]
    }
    return fieldName
  },

  itemSaveCallback (id) {
    if (this.parentId) {
      // Subtable
      if (this.subtableSelectedId && !id) {
        // Delete
        this.subtableSelectedId = null
      } else if (this.subtableSelectedId === '0' && id) {
        // New item
        this.subtableSelectedId = null
        // set = id if want to remain on form
      }
    } else {
      // Direct form in main list
      if (this.id === '0' && id) {
        // New item
        this.$router.push('/' + this.moduleName + '/form/' + id)
      } else if (!id && this.id) {
        // Deleted. refresh
        this.$router.push('/' + this.moduleName)
      }
      this.openList()
    }
  },

  backToList () {
    if (this.parentId) {
      this.$parent.subtableSelectedId = null
    } else {
      this.$router.push('/' + this.moduleName)
    }
  },

  gridColumns (field) {
    if (this.$vuetify.breakpoint.smAndDown) {
      return 12
    }
    if (field.info.gridSize) {
      return field.info.gridSize
    }
    return 12
  },

  unitSelectOptions () {
    return this.units.map((unit) => {
      return unit.unitCode
    })
  },

  firstLetterUppercase (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
}
